export default __webpack_public_path__ + "static/media/wood-icon.31a0878b.svg";